import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['outputContainer', 'input']

  selectImage() {
    this.inputTarget.click();
  }

  displayImagePreview(event) {
    event.preventDefault();

    const input = this.inputTarget;
    const outputContainer = this.outputContainerTarget;

    // Clear previous preview content
    outputContainer.innerHTML = '';

    if (input.files && input.files[0]) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageSrc = e.target.result;

        // Update the outputContainer content instead of replacing it
        outputContainer.className = 'flex gap-2 items-center';

        // Remove the click action from outputContainer since we now have an image
        outputContainer.removeAttribute('data-action');
        outputContainer.classList.remove('cursor-pointer');

        // Create the image wrapper with fixed size
        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'rounded-md overflow-hidden w-18 h-18';

        // Create the image element
        const img = document.createElement('img');
        img.src = imageSrc;
        img.className = 'w-full h-full object-cover';

        imageWrapper.appendChild(img);

        // If enabled, overlay an eye icon and open lightbox on click (same as server-rendered)
        if (this.element?.dataset?.enableViewButton === 'true') {
          imageWrapper.classList.add('relative', 'cursor-zoom-in')
          imageWrapper.addEventListener('click', () => this.openLightbox(imageSrc))

          const overlay = document.createElement('div')
          overlay.className = 'absolute inset-0 bg-black/50'
          const eye = document.createElement('i')
          eye.className = 'ph-bold ph-eye absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white'
          imageWrapper.appendChild(overlay)
          imageWrapper.appendChild(eye)
        }

        // Create the "Change" span
        const changeSpan = document.createElement('span');
        changeSpan.className = 'text-purple-light cursor-pointer text-xs';
        changeSpan.dataset.action = 'click->preview-image#selectImage';
        changeSpan.textContent = 'Change';

        // Append elements to the existing outputContainer
        outputContainer.appendChild(imageWrapper);
        outputContainer.appendChild(changeSpan);

        // Notify parent components so they can update live previews
        const kind = this.element?.dataset?.imageKind || 'cover'
        const evt = new CustomEvent('asset:image-changed', {
          detail: { kind, src: imageSrc, hasFile: true },
          bubbles: true
        })
        this.element.dispatchEvent(evt)
      };

      reader.readAsDataURL(input.files[0]);
    }
  }

  openLightbox(eventOrSrc) {
    try {
      let imageSrc
      if (typeof eventOrSrc === 'string') {
        imageSrc = eventOrSrc
      } else {
        const fromClick = eventOrSrc?.currentTarget?.querySelector?.('img')?.src
        imageSrc = fromClick || this.outputContainerTarget.querySelector('img')?.src
      }
      if (!imageSrc) return

      const overlay = document.createElement('div')
      overlay.className = 'fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4'
      overlay.addEventListener('click', () => overlay.remove())

      const img = document.createElement('img')
      img.src = imageSrc
      img.className = 'max-w-[90vw] max-h-[90vh] object-contain rounded-lg shadow-lg'
      img.addEventListener('click', (e) => e.stopPropagation())

      const closeBtn = document.createElement('button')
      closeBtn.type = 'button'
      closeBtn.className = 'absolute top-4 right-4 text-white text-2xl'
      closeBtn.innerHTML = '<i class="ph-bold ph-x"></i>'
      closeBtn.addEventListener('click', () => overlay.remove())

      overlay.appendChild(img)
      overlay.appendChild(closeBtn)
      document.body.appendChild(overlay)
    } catch (_) {}
  }
}
